import './styles.css';
import React, { useState, useEffect, useRef,} from "react";
import { toast } from "react-toastify";
import { useQuery } from '@tanstack/react-query';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { CHART_TYPE, DB_DATA_FIELDS, DB_ICONS, LAYOUTS } from './dbConstants';
import { exportToCSV, generateLayout, getFieldsList } from "./dbUtils";
import { getData } from 'apis/dataApis';
import ToolBar from "./Toolbar/ToolBar";
import LocationLayout from './LocationLayout';
import ChartsLayout from './ChartsLayout';
import DataGrid from './DataGrid';

const DBLayout = ({vehicle, dateRange}) => {
    // const [queryFields, setQueryFields] = useState({});
    // const telemetryFields = DB_DATA_FIELDS.TELEMETRY.children.map((field) => field.value);
    const telemetryFields = DB_DATA_FIELDS.TELEMETRY.children
    const [selectedFieldsList, setSelectedFieldsList] = useState(telemetryFields);
    const [selectedLayout, setSelectedLayout] = useState(LAYOUTS.TELEMETRY);
    const [layouts, setLayouts] = useState({}); 
    const [selectedChart, setSelectedChart] = useState(CHART_TYPE.TIMESERIES);
    const [crossHair, setCrossHair] = useState(false);
    const [enableZoom, setEnableZoom] = useState(false);
    const [showDataModal, setShowDataModal] = useState(false);
    
    const chartLayoutRef = useRef();
    const locationLayoutRef = useRef();

    const { data, isLoading, isError, error, } = useQuery({
      queryKey: ['chartData', vehicle?.vehImei, selectedFieldsList, selectedLayout, dateRange],
      queryFn: () => getData(vehicle?.vehImei, 
        selectedFieldsList.map((field) => field.value), 
        selectedLayout, dateRange[0], dateRange[1], '1m'),      
      retry: 2,
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5,
      enabled: !!(vehicle?.vehImei, selectedFieldsList, selectedLayout, dateRange?.length),
    });

    const onClickDataIcon = () => {
      setShowDataModal(true);
    }
  
    const onCloseDataModal = () => {
      setShowDataModal(false);
    }

    const onSelectedChartChange = (chartType) => {
      setSelectedChart(CHART_TYPE[chartType.toUpperCase()]);
      if([CHART_TYPE.HISTOGRAM, CHART_TYPE.BOXPLOT].includes(chartType) && crossHair){
        setCrossHair(false);
      }
    }

    const onOtherIconsClick = (icon) => {
      switch(icon){
        case DB_ICONS.CROSSHAIR: onClickCrossHair(); break;
        case DB_ICONS.ZOOM_IN: onClickEnableZoom(); break;
        case DB_ICONS.ZOOM_RESET: onClickZoomReset(); break;
        case DB_ICONS.DATA: onClickDataIcon(); break;
        case DB_ICONS.DOWNLOAD: onClickDownload(); break;
        default:
      }
    }

    const onSelectedLayoutChange = (layout) => {
      setSelectedLayout(layout);
      setSelectedFieldsList(getFieldsList(layout));
    }

    const onClickCrossHair = () => {
      setCrossHair((prev) => !prev);
    }

    const onClickEnableZoom = () => {
      if (selectedChart === CHART_TYPE.TIMESERIES || selectedChart === CHART_TYPE.SCATTER) {
        setEnableZoom((prev) => !prev);
      } 
    }

    const onClickZoomReset = () => {
      if (selectedChart === CHART_TYPE.TIMESERIES || selectedChart === CHART_TYPE.SCATTER) {
        setEnableZoom(false);
        if (selectedLayout === LAYOUTS.LOCATION) {
          locationLayoutRef?.current?.resetZoomAll();
        } else {
          chartLayoutRef?.current?.resetZoomAll();
        }
      }
    }

    const onClickDownload = () => {
      if (data?.data.length){
        exportToCSV(data?.data, selectedLayout.toLowerCase())
      } else {
        toast.info('Dataset is Empty', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
          closeButton: false,
        }); 
      }       
    }

    // useEffect(() => {
    //   const keys = Object.keys(queryFields);
    //   let fieldsList = [];
    //   keys.forEach((key) =>{
    //     if (queryFields[key].length){
    //       fieldsList.push(...queryFields[key]);
    //     }
    //   });
    //   setSelectedFieldsList(fieldsList); 
    // }, [queryFields])

    useEffect(() => {
      let layout = generateLayout(selectedLayout);
      setLayouts(layout);
    }, [selectedLayout])

  return (
    <>
      <div className="dbcontainer">
        <div className="toolbar">
          <ToolBar
            selectedChart={selectedChart}
            selectedLayout={selectedLayout}
            crossHair={crossHair}
            enableZoom={enableZoom}
            onChartChange={onSelectedChartChange}
            onLayoutChange={onSelectedLayoutChange}
            onOtherIconsClick={onOtherIconsClick}
          />
        </div>
        <div className="dashboard-layout">
          {showDataModal && 
            <DataGrid
              dataModalOpen={showDataModal}
              title = {selectedLayout === 'IMU' ? 'Accelerometer Data' :
                `${selectedLayout[0].toUpperCase() + selectedLayout.slice(1).toLowerCase()} Data`}
              gridData={data?.data}
              gridField={selectedFieldsList?.map((f) => f.value)}
              onCloseModal={onCloseDataModal}
            />
          }
          {selectedLayout === LAYOUTS.LOCATION ?
            <LocationLayout 
              layouts={layouts} 
              selectedChart={selectedChart}
              data={data}
              isLoading={isLoading}
              isError={isError}
              error={error}
              crossHair={crossHair}
              enableZoom={enableZoom}
              onZoomReset={onClickZoomReset}
              ref={locationLayoutRef}
            />
          :
            <ChartsLayout 
              layouts={layouts} 
              selectedChart={selectedChart}
              data={data}
              isLoading={isLoading}
              isError={isError}
              error={error}
              fields={selectedFieldsList}
              crossHair={crossHair}
              enableZoom={enableZoom}
              onZoomReset={onClickZoomReset}
              ref={chartLayoutRef}
            />
          }
        </div>
      </div>
    </>
  );
};

export default DBLayout;
